
// @ts-nocheck


export const localeCodes =  [
  "zh",
  "zh-TW",
  "en",
  "ja",
  "ko",
  "fr",
  "de",
  "es"
]

export const localeLoaders = {
  zh: [],
  "zh-TW": [],
  en: [],
  ja: [],
  ko: [],
  fr: [],
  de: [],
  es: []
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/db048695" /* webpackChunkName: "config_i18n_46config_46ts_db048695" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "zh",
      name: "简体中文",
      files: []
    },
    {
      code: "zh-TW",
      name: "繁體中文",
      files: []
    },
    {
      code: "en",
      name: "English",
      files: []
    },
    {
      code: "ja",
      name: "日本語",
      files: []
    },
    {
      code: "ko",
      name: "한국어",
      files: []
    },
    {
      code: "fr",
      name: "Français",
      files: []
    },
    {
      code: "de",
      name: "Deutsch",
      files: []
    },
    {
      code: "es",
      name: "Español",
      files: []
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "zh",
    name: "简体中文",
    files: []
  },
  {
    code: "zh-TW",
    name: "繁體中文",
    files: []
  },
  {
    code: "en",
    name: "English",
    files: []
  },
  {
    code: "ja",
    name: "日本語",
    files: []
  },
  {
    code: "ko",
    name: "한국어",
    files: []
  },
  {
    code: "fr",
    name: "Français",
    files: []
  },
  {
    code: "de",
    name: "Deutsch",
    files: []
  },
  {
    code: "es",
    name: "Español",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/